export default "__VITE_ASSET__CX1c0Nna__"